<div *ngIf="(!offer || isLoadingView) && offerFound" style="text-align: center;" id="offerSpinner">
  <app-loading-spinner></app-loading-spinner>
</div>

<div *ngIf="!offerFound" [innerHTML]="translationService.getTranslation('offer_not_found')" data-cy="offer-not-found"></div>
<div class="offerContainer" #offerContainer *ngIf="offer && !isLoadingView" (window:resize)="onResize($event)">
  <app-general-errors [errors]="errorsArr"></app-general-errors>
  <div class="row">
    <div class="col-12 col-md-8">
      <mat-stepper appMatVerticalStepperScroller [linear]="true" #stepper [orientation]="stepperOrientation"
                   labelPosition="bottom" (selectionChange)="stepperSelectionChanged($event)">
        <!-- Upselling -->
        <!-- Mit *ngIf="false && ..." ist der Block deaktiviert und bringt somit eine Warnung
          <mat-step [stepControl]="upsellingFormGroup" [editable]="isEditable"
                  *ngIf="false && offer.combinedOfferList">
            <form [formGroup]="loginFormGroup" class="mt-3">
              <ng-template matStepLabel>
                <div [innerHTML]="translationService.getTranslation('step_upselling')"></div>
              </ng-template>
              <div *ngFor="let combinedOffer of offer.combinedOfferList">
                <app-offer-card [offer]="combinedOffer"></app-offer-card>
              </div>

              <div class="float-end mt-3">
                <button mat-raised-button color="primary"
                        matStepperNext [innerHTML]="translationService.getTranslation('button_next')"></button>
              </div>
            </form>
          </form>
          </mat-step>
        -->

        <!-- Registrierung (opt.) -->
        <mat-step [stepControl]="loginFormGroup" [editable]="isEditable" *ngIf="!isAuthenticated && !hideLoginBox">
          <form [formGroup]="loginFormGroup" class="mt-3" (ngSubmit)="onRegisterNext($event, stepper)">
            <ng-template matStepLabel>
              <div [innerHTML]="translationService.getTranslation('step_orderRegister')"></div>
            </ng-template>
            <mat-card appearance="outlined" class="mt-3">
              <mat-card-content>
                <div class="row">
                  <div class="col-12"
                       [innerHTML]="translationService.getTranslation('account_already_exists_description')"></div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card appearance="outlined" class="mt-3">
              <mat-card-content>
                <div class="row">
                  <div class="col-12 pl-15" [innerHTML]="translationService.getTranslation('account_register')"></div>
                </div>
                <mat-form-field class="col-12 mt-3">
                  <mat-label [innerHTML]="translationService.getTranslation('register_email')"></mat-label>
                  <input matInput formControlName="email" required
                         [value]="loginFormGroup.get('email').value"
                         [class.is-valid]="loginFormGroup.get('email').valid">
                  <mat-spinner class="iconInInput" *ngIf="loginFormGroup.get('email').pending"
                               matSuffix [diameter]="18"
                               style="float: right; margin-left: 18px"></mat-spinner>
                  <mat-icon class="iconInInput" *ngIf="loginFormGroup.get('email').valid" matSuffix>
                    check
                  </mat-icon>
                  <mat-error *ngIf="loginFormGroup.get('email').status == 'INVALID'">
                    {{ loginFormGroup.get('email').hasError('required')
                        ? translationService.getTranslation('error_email_empty')
                        : translationService.getTranslation('error_email_invalid') }}
                  </mat-error>
                </mat-form-field>
                <ng-container *ngIf="registerPasswordVisible">
                  <div class="row">
                    <div class="col-12 mt-3" [innerHTML]="translationService.getTranslation('offer.register.passwordText')"></div>
                  </div>
                  <mat-form-field class="col-12 mt-2 mb-3" [hintLabel]="getPasswordComplexityHint()">
                    <mat-label [innerHTML]="translationService.getTranslation('register_password')"></mat-label>
                    <input matInput formControlName="password" type="password" required
                           [value]="loginFormGroup.get('password').value"
                           [class.is-valid]="loginFormGroup.get('password').valid">
                    <mat-spinner class="iconInInput" *ngIf="loginFormGroup.get('password').pending"
                                 matSuffix [diameter]="18"
                                 style="float: right; margin-left: 18px"></mat-spinner>
                    <mat-icon class="iconInInput" *ngIf="loginFormGroup.get('password').valid" matSuffix>check</mat-icon>
                    <mat-error *ngIf="loginFormGroup.get('password').invalid" [innerHTML]="getPasswordErrorMessage()"></mat-error>
                  </mat-form-field>
                </ng-container>
              </mat-card-content>
            </mat-card>

            <div class="float-end mt-3">
              <button mat-raised-button color="primary" type="submit"
                      data-matStepperNext [innerHTML]="translationService.getTranslation('button_next')"></button>
            </div>
          </form>
        </mat-step>

        <!-- Prämien (opt.) -->
        <mat-step [stepControl]="bonusFormGroup" [editable]="isEditable" *ngIf="bonusSelection">
          <app-general-warning class="row" *ngIf="currentProductAlreadyOrdered" [warnings]="[{infoText: translationService.getTranslation('currentProduct.alreadyOrdered')}]"></app-general-warning>
          <form [formGroup]="bonusFormGroup" class="mt-3">

            <ng-template matStepLabel>
              <div [innerHTML]="translationService.getTranslation('step_orderBonus')"></div>
            </ng-template>

            <div class="container-fluid p-0">
              <div class="row">
                <div class="col-12">
                  <div id="bonusCard">
                    <div class="row">
                      <ng-container *ngFor="let bonus of bonuses; let i = index">
                        <ng-container *ngIf="i < maxBonuses">
                          <div [className]=" 'mb-3 ' +
                                             'col-' + (CssPropertiesEnum.bonusFxFlex|cssProperty: vHostService) + ' ' +
                                             'col-sm-' + (CssPropertiesEnum.bonusFxFlexSM|cssProperty: vHostService) + ' ' +
                                             'col-md-' + (CssPropertiesEnum.bonusFxFlexMD|cssProperty: vHostService) + ' ' +
                                             'col-lg-' + (CssPropertiesEnum.bonusFxFlexLG|cssProperty: vHostService) + ' ' +
                                             'col-xl-' + (CssPropertiesEnum.bonusFxFlexXL|cssProperty: vHostService) + ' ' +
                                             'col-xxl-' + (CssPropertiesEnum.bonusFxFlexXXL|cssProperty: vHostService)">
                            <mat-card appearance="outlined" class="mat-elevation-z4 pointer h-100"
                                      [ngClass]="bonus.selected ? 'selectedBonus' : 'unselectedBonus'">
                              <mat-card-header>
                                <mat-card-title class="pb-0" (click)="onSelectBonus(bonus, bonusNextButton)">
                                  <div>{{ bonus.name }}</div>
                                </mat-card-title>
                              </mat-card-header>
                              <div class="bonusBody my-4 h-100" (click)="onSelectBonus(bonus, bonusNextButton)">
                                <img class="mw-100" mat-card-image
                                     *ngIf="bonus?.image"
                                     [ngSrc]="bonus.image.src"
                                     [width]="imageService.width"
                                     [height]="imageService.height"
                                     [priority]="true"
                                     [alt]="bonus.image.altText"
                                     (click)="onSelectBonus(bonus, bonusNextButton)">
                              </div>
                              <div class="bonusFooter row">
                                <div class="col-12 text-center">
                                  <button class="detailBonusButton btn btn-secondary m-2" mat-flat-button color="primary"
                                          (click)="onShowDetails(bonus)"
                                          data-cy="btn-show-bonus-details"
                                          [innerHTML]="translationService.getTranslation('button_details')"></button>
                                </div>
                                <div class="col-12 text-center">
                                  <button class="selectBonusButton m-2" mat-raised-button color="primary"
                                          (click)="onSelectBonus(bonus, bonusNextButton)"
                                          data-cy="btn-select-bonus"
                                          [innerHTML]="translationService.getTranslation('button_bonus_select')"></button>
                                </div>
                              </div>
                            </mat-card>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="col-12 mt-3 mb-5 text-center" *ngIf="bonuses.length > maxBonuses">
                  <button mat-raised-button color="primary"
                          (click)="loadMoreBonuses()"
                          [innerHTML]="translationService.getTranslation('button_more_bonuses')"></button>
                </div>
              </div>
            </div>

            <div class="col-12 mt-1">
              <div *ngFor="let bonus of getBonusControls(); let i = index">
                <mat-checkbox (click)="onDeselectBonus(i)" checked="checked" class="text-wrap">
                  <div [innerHTML]="bonus.value.name"></div>
                </mat-checkbox>
              </div>
            </div>

            <div class="col-12 mt-5" *ngIf="!selectedBonus" [innerHTML]="translationService.getTranslation('offer.missingBonus')"></div>

            <div class="float-end mt-1" #bonusNextButton>
              <button class="me-3" mat-raised-button
                      matStepperPrevious
                      *ngIf="!isAuthenticated" [innerHTML]="translationService.getTranslation('button_back')"></button>
              <button align="end" mat-raised-button color="primary" data-cy="btn-bonus-next"
                      matStepperNext [innerHTML]="translationService.getTranslation('button_next')"></button>
            </div>
          </form>
        </mat-step>

        <!-- Durch das Entfernen von [stepControl]="addressFormGroup" aus dem <mat-step> und das Setzen von [disabled]="!addressValid" am Button mit matStepperNext
        wird die Validierungslogik für das Weitersteppen individuell gesteuert. Standardmäßig prüft der Stepper die Gültigkeit des gesamten FormGroups – auch Felder,
        die per *ngIf nicht sichtbar sind, beeinflussen die Validität. Um zu verhindern, dass unsichtbare Formularteile
        (z.B. durch *ngIf ausgeblendete Controls) die Validierung blockieren, werden diese Controls entweder dynamisch aus dem FormGroup entfernt oder deaktiviert,
        solange sie nicht sichtbar sind. So wird das Weitersteppen nur noch von der eigenen Logik (z.B. addressValid) abhängig gemacht und nicht mehr von der Angular-internen Stepper-Validierung.
        Dadurch zählen nur die tatsächlich sichtbaren und relevanten Felder für die Validierung und das Weitersteppen. -->
        <!-- Adressen -->
        <mat-step *ngIf="offer.offerType.ePaper && offer.requiredAddresses.billingAddressRequired || offer.requiredAddresses.deliveryAddressRequired" [editable]="isEditable">
          <form [formGroup]="addressFormGroup" class="mt-md-5 mt-3">
            <app-general-warning *ngIf="currentProductAlreadyOrdered" [warnings]="[{infoText: translationService.getTranslation('currentProduct.alreadyOrdered')}]"></app-general-warning>
            <div *ngIf="userData && userData?.userBackendId > 0">
              <div class="mb-3" [innerHTML]="translationService.getTranslation('offer_address_readonly')"></div>
              <app-hup-subscription-address
                [isReadOnly]="true"
                [askForBirthday]="askForBirthday"
                [isBirthdayRequired]="isBirthdayRequired"
                [askForPhone]="askForPhone"
                [isPhoneRequired]="isPhoneRequired"
                [showAddressExt1]="false"
                [controlGroup]="deliveryAddressGroup">
              </app-hup-subscription-address>
              <!--Abweichende Rechnungsadresse -->
              <ng-container *ngIf="!onlyOneAddress && offer.requiredAddresses.billingAddressRequired">
                <ng-container class="mt-md-5 mt-3">
                  <!--suppress TypeScriptValidateTypes -->
                  <app-hup-subscription-address [showActivateCheckbox]="true"
                                                [askForBirthday]="askForBirthday"
                                                [askForEmail]="askForEmail"
                                                [controlGroup]="billingAddressGroup"
                                                [activateCheckboxText]="'address_diffBilling'">
                  </app-hup-subscription-address>
                </ng-container>
              </ng-container>
              <!-- Abweichende Prämienadresse -->
              <br>
              <ng-container *ngIf="!onlyOneAddress && bonuses.length >= 1 && bonuses[0].bonusType == BonusType.NON_MONEY_BONUS">
                <ng-container class="mt-md-5 mt-1">
                  <!--suppress TypeScriptValidateTypes -->
                  <app-hup-subscription-address [showActivateCheckbox]="true"
                                                [askForBirthday]="askForBirthday"
                                                [askForEmail]="askForEmail"
                                                [controlGroup]="bonusAddressGroup"
                                                [activateCheckboxText]="'address_diffBonus'">
                  </app-hup-subscription-address>
                </ng-container>
              </ng-container>
              <br>
              <div class="mt-3 float-end mb-3 d-none">
                <button mat-button class="btn-secondary">
                  <mat-icon>edit</mat-icon>
                  Adresse ändern
                </button>
              </div>
              <div class="clearfix"></div>
            </div>

            <div [className]="(userData && userData?.userBackendId > 0) ? 'd-none' : ''">
            <ng-template matStepLabel>
              <div [innerHTML]="translationService.getTranslation('step_orderAddr')"></div>
            </ng-template>
              <!--Neuer Kunde -->
              <app-general-warning *ngIf="offer.offerType.ePaper && showWarningForOrderWithoutAddress && clientWithoutAddressActivated"
                [warnings]="[{infoText: translationService.getTranslation('subscription.client-without-address.warning-text')}]">
              </app-general-warning>
            <ng-container
              *ngIf="offer && offer.requiredAddresses.deliveryAddressRequired && offer.requiredAddresses.billingAddressRequired">

              <app-hup-subscription-address
                [showActivateCheckbox]="false"
                [askForBirthday]="askForBirthday"
                [askForEmail]="askForEmail"
                [askForPhone]="askForPhone"
                [isPhoneRequired]="isPhoneRequired"
                [isBirthdayRequired]="isBirthdayRequired"
                [controlGroup]="deliveryAddressGroup"
                [forProductType]="offer">
              </app-hup-subscription-address>
              <ng-container *ngIf="!onlyOneAddress">
                <app-hup-subscription-address
                  [showActivateCheckbox]="true"
                  [askForPhone]="askForPhone"
                  [isPhoneRequired]="isPhoneRequired"
                  [controlGroup]="billingAddressGroup"
                  activateCheckboxText="address_diffBilling">
                </app-hup-subscription-address>
              </ng-container>
            </ng-container>

            <ng-container
              *ngIf="!offer.requiredAddresses.deliveryAddressRequired && offer.requiredAddresses.billingAddressRequired">

              <app-hup-subscription-address
                [showActivateCheckbox]="false"
                [askForBirthday]="askForBirthday"
                [askForEmail]="askForEmail"
                [askForPhone]="askForPhone"
                [isPhoneRequired]="isPhoneRequired"
                [isBirthdayRequired]="isBirthdayRequired"
                [controlGroup]="billingAddressGroup"
                activateCheckboxText="address_diffBilling"
                [forProductType]="offer">
              </app-hup-subscription-address>
            </ng-container>

            <ng-container
              *ngIf="offer.requiredAddresses.deliveryAddressRequired && !offer.requiredAddresses.billingAddressRequired">
              <app-hup-subscription-address
                [showActivateCheckbox]="false"
                [askForBirthday]="askForBirthday"
                [askForEmail]="askForEmail"
                [askForPhone]="askForPhone"
                [isPhoneRequired]="isPhoneRequired"
                [isBirthdayRequired]="isBirthdayRequired"
                [controlGroup]="deliveryAddressGroup"
                [forProductType]="offer">
              </app-hup-subscription-address>
            </ng-container>
            <ng-container *ngIf="bonuses.length >= 1 && bonusSelection">
            <!--suppress TypeScriptValidateTypes -->
              <!--Prämienadresse: -->
              <app-hup-subscription-address
                *ngIf="showBonusAddress && bonuses[0].bonusType == BonusType.NON_MONEY_BONUS"
                [showActivateCheckbox]="true"
                [askForPhone]="askForPhone"
                [isPhoneRequired]="isPhoneRequired"
                [controlGroup]="bonusAddressGroup"
                [activateCheckboxText]="'address_diffBonus'">
              </app-hup-subscription-address>

              <!--Werber-Adresse: -->
              <app-hup-subscription-address *ngIf="bonuses[0].bonusType == BonusType.THIRD_PARTY_NON_MONEY_BONUS"
                                            [showActivateCheckbox]="false"
                                            [askForBirthday]="false"
                                            [askForEmail]="false"
                                            [controlGroup]="advertiserAddressGroup"
                                            [addressType]="translationService.getTranslation('address_advertiser')">
              </app-hup-subscription-address>
            </ng-container>

            </div>
            <mat-form-field *ngIf="hideLoginBox && !isWinback" class="col-12 ps-2">
              <mat-label [innerHTML]="translationService.getTranslation('register_email')"></mat-label>
              <input matInput formControlName="email" required
                     data-cy="input-email"
                     [value]="addressFormGroup.get('email').value"
                     [class.is-valid]="addressFormGroup.get('email').valid">
              <mat-spinner class="iconInInput" *ngIf="addressFormGroup.get('email').pending"
                           matSuffix [diameter]="18"
                           style="float: right; margin-left: 18px"></mat-spinner>
              <mat-icon class="iconInInput" *ngIf="addressFormGroup.get('email').valid" matSuffix>
                check
              </mat-icon>
              <mat-error *ngIf="addressFormGroup.get('email').status == 'INVALID'">
                {{ addressFormGroup.get('email').hasError('required')
                    ? translationService.getTranslation('error_email_empty')
                    : translationService.getTranslation('error_email_invalid') }}
              </mat-error>
            </mat-form-field>

            <div class="float-end mt-1">
              <button class="me-3" mat-raised-button
                      matStepperPrevious *ngIf="!userData"
                      [innerHTML]="translationService.getTranslation('button_back')"></button>
              <button mat-raised-button color="primary"
                      [disabled]="!formValid"
                      matStepperNext data-cy="btn-address-next"
                      (click)="onSelectAddresses();setStartDate();setUniquePaymentInfos();"
                      [innerHTML]="translationService.getTranslation('button_next')"></button>
            </div>
          </form>
        </mat-step>

        <!-- Zahlungsdetails -->
        <mat-step [stepControl]="paymentFormGroup" [editable]="isEditable">
          <app-general-warning class="row" *ngIf="currentProductAlreadyOrdered" [warnings]="[{infoText: translationService.getTranslation('currentProduct.alreadyOrdered')}]"></app-general-warning>
          <form [formGroup]="paymentFormGroup" class="mt-3">
            <ng-template matStepLabel>
              <div [innerHTML]="translationService.getTranslation('step_orderPayment')"></div>
            </ng-template>

            <ng-container formArrayName="extendedData">
              <div *ngFor="let field of getAdditionalDataControls(); let i = index">
                <mat-form-field class="col-12">
                  <mat-label>{{ additionalData[i].description }}</mat-label>
                  <input matInput [formControlName]="i" [value]="field.value">
                  <mat-error *ngIf="field.hasError('message')">{{ field.getError('message') }}
                  </mat-error>
                </mat-form-field>
              </div>
            </ng-container>

            <div class="col-12" [innerHTML]="translationService.getTranslation('choseFormOfPayment')"></div>
            <!--Zahldaten für das Abo-->
              <div class="row">
                <div [className]="'mb-3' + ' ' +
                  'col-' + (CssPropertiesEnum.formOfPaymentFxFlex|cssProperty: vHostService) + ' ' +
                  'col-sm-' + (CssPropertiesEnum.formOfPaymentFxFlexSM|cssProperty: vHostService) + ' ' +
                  'col-md-' + (CssPropertiesEnum.formOfPaymentFxFlexMD|cssProperty: vHostService) + ' ' +
                  'col-lg-' + (CssPropertiesEnum.formOfPaymentFxFlexLG|cssProperty: vHostService) + ' ' +
                  'col-xl-' + (CssPropertiesEnum.formOfPaymentFxFlexXL|cssProperty: vHostService) + ' ' +
                  'col-xxl-' + (CssPropertiesEnum.formOfPaymentFxFlexXXL|cssProperty: vHostService)"
                     *ngFor="let formOfPayment of formsOfPayment">
                  <div data-bs-toggle="collapse" tabindex="0" (keydown.space)="onSelectFormOfPayment(formOfPayment)" (keydown.enter)="onSelectFormOfPayment(formOfPayment)" (click)="onSelectFormOfPayment(formOfPayment)" data-cy="choose-form-of-payment">
                    <label class="card-radio-label w-100">
                      <input type="radio" name="pay-method" id="pay-methodoption1" class="card-radio-input" [checked]="formOfPayment === selectedFormOfPayment">
                      <span class="card-radio py-3 text-center text-truncate">
                        <fa-icon *ngIf="!formOfPayment?.image" [icon]="'euro'" class="euroicon d-block h2"></fa-icon>
                        <img *ngIf="formOfPayment?.image?.src"
                             [ngSrc]="formOfPayment?.image?.src"
                             [width]="imageService.width"
                             [height]="imageService.height"
                             [alt]="formOfPayment?.image?.altText"
                             class="custom-icon d-block h2"/>
                        {{formOfPayment.description}}
                      </span>
                    </label>
                  </div>
                </div>
                <mat-error *ngIf="paymentFormGroup.get('formOfPayment').hasError('message')"
                  [innerHTML]="paymentFormGroup.get('formOfPayment').getError('message')"></mat-error>
              </div>

            <!--Zahlungsrhythmus-->
            <mat-form-field class="col-12">
              <mat-label [innerHTML]="translationService.getTranslation('payment_rhythm')"></mat-label>
              <mat-select formControlName="paymentFrequency" required
                          [value]="paymentFormGroup.get('paymentFrequency').value" data-cy="select-payment-frequency">
                <ng-container *ngFor="let paymentFrequency of paymentFrequencies">
                  <mat-option *ngIf="paymentFrequency.useInFE"
                              data-cy="option-payment-frequency"
                              [value]="paymentFrequency">{{ paymentFrequency.description }}
                  </mat-option>
                </ng-container>
              </mat-select>
              <mat-error
                *ngIf="paymentFormGroup.get('paymentFrequency').hasError('message')">{{ paymentFormGroup.get('paymentFrequency').getError('message') }}
              </mat-error>
            </mat-form-field>

            <ng-container *ngIf="needIbanBic">
              <mat-form-field class="col-12">
                <mat-label [innerHTML]="translationService.getTranslation('payment_iban')"></mat-label>
                <input maxLength="34" matInput formControlName="iban" [value]="paymentFormGroup.get('iban').value"
                       oninput="this.value = this.value.toUpperCase()" (keyup) = "transferIban()" #iban data-cy="input-iban">
                <mat-hint *ngIf="iban === document?.activeElement && iban.value.length >= 1" align="end">{{iban.value.length}} / {{iban.maxLength}}</mat-hint>
                <mat-error
                  *ngIf="paymentFormGroup.get('iban').hasError('message')">{{ paymentFormGroup.get('iban').getError('message') }}
                </mat-error>
              </mat-form-field>
              <div *ngIf="paymentFormGroup.get('iban').status === 'PENDING'">
                <app-loading-spinner [type]="'small'"></app-loading-spinner>
              </div>

              <mat-form-field class="col-12">
                <mat-label [innerHTML]="translationService.getTranslation('payment_bic')"></mat-label>
                <input matInput formControlName="bic" [value]="paymentFormGroup.get('bic').value" data-cy="input-bic">
                <mat-error
                  *ngIf="paymentFormGroup.get('bic').hasError('message')">{{ paymentFormGroup.get('bic').getError('message') }}
                </mat-error>
              </mat-form-field>

              <mat-form-field class="col-12" *ngIf="askForPaymentAccountHolder">
                <mat-label [innerHTML]="translationService.getTranslation('payment_holder')"></mat-label>
                <input matInput minlength="1" maxlength="255" formControlName="accountHolder" [value]="paymentFormGroup.get('accountHolder').value" data-cy="input-bic" #accountHolder>
                <mat-hint *ngIf="accountHolder === document?.activeElement && accountHolder.value.length >= 1" align="end">{{accountHolder.value.length}} / {{accountHolder.maxLength}}</mat-hint>
                <mat-error
                  *ngIf="paymentFormGroup.get('accountHolder').hasError('message')">{{ paymentFormGroup.get('accountHolder').getError('message') }}
                </mat-error>
              </mat-form-field>
            </ng-container>

            <!--Zahlungsdetails für die Prämie-->
            <ng-container *ngIf="moneyBonusSelected || nonMoneyBonusWithClientCoPaymentSelected">
              <app-general-warning *ngIf="nonMoneyBonusWithClientCoPaymentSelected"
                                   [warnings]="[{infoText: translationService.getTranslation('bonus.co-payment.notification')}]">
              </app-general-warning>

              <mat-form-field class="col-12">
                <mat-label>{{ translationService.getTranslation('payment_iban_bonus') }}</mat-label>
                <input maxlength="34" matInput formControlName="ibanBonus"
                       [value]="paymentFormGroup.get('ibanBonus').value"
                       oninput="this.value = this.value.toUpperCase()" #ibanBonus>
                <mat-hint *ngIf="ibanBonus === document?.activeElement && ibanBonus.value.length >= 1"
                          align="end">{{ ibanBonus.value.length }} / {{ ibanBonus.maxLength }}
                </mat-hint>
                <mat-error
                  *ngIf="paymentFormGroup.get('ibanBonus').hasError('message')">{{ paymentFormGroup.get('ibanBonus').getError('message') }}
                </mat-error>
              </mat-form-field>
              <div *ngIf="paymentFormGroup.get('ibanBonus').status === 'PENDING'">
                <app-loading-spinner [type]="'small'"></app-loading-spinner>
              </div>

              <mat-form-field class="col-12">
                <mat-label>{{ translationService.getTranslation('payment_bic_bonus') }}</mat-label>
                <input matInput formControlName="bicBonus" [value]="paymentFormGroup.get('bicBonus').value">
                <mat-error
                  *ngIf="paymentFormGroup.get('bicBonus').hasError('message')">{{ paymentFormGroup.get('bicBonus').getError('message') }}
                </mat-error>
              </mat-form-field>

              <mat-form-field class="col-12" *ngIf="askForPaymentAccountHolder">
                <mat-label>{{ translationService.getTranslation('payment_holder_bonus') }}</mat-label>
                <input matInput formControlName="accountHolderBonus" [value]="paymentFormGroup.get('accountHolderBonus').value" #accountHolderBonus>
                <mat-hint *ngIf="accountHolderBonus === document?.activeElement && accountHolderBonus.value.length >= 1" align="end">{{accountHolderBonus.value.length}} / {{accountHolderBonus.maxLength}}</mat-hint>
                <mat-error
                  *ngIf="paymentFormGroup.get('accountHolderBonus').hasError('message')">{{ paymentFormGroup.get('accountHolderBonus').getError('message') }}
                </mat-error>
              </mat-form-field>
            </ng-container>

            <ng-container *ngIf="needInvoiceMailAddress">
              <mat-form-field class="col-12">
                <mat-label [innerHTML]="translationService.getTranslation('payment_invoice_email')"></mat-label>
                <input maxLength="50" matInput formControlName="invoiceEmail"
                       [value]="paymentFormGroup.get('invoiceEmail').value" #email>
                <mat-hint *ngIf="email === document?.activeElement && email.value.length >= 1" align="end">{{email.value.length}} / {{email.maxLength}}</mat-hint>
                <mat-error *ngIf="paymentFormGroup.get('invoiceEmail').status == 'INVALID'">
                  {{ paymentFormGroup.get('invoiceEmail').hasError('required')
                      ? translationService.getTranslation('error_email_empty')
                      : translationService.getTranslation('error_email_invalid') }}
                </mat-error>
              </mat-form-field>
            </ng-container>
            <mat-form-field class="col-12" (click)="picker1.open()">
              <mat-label [innerHTML]="translationService.getTranslation('startdate')"></mat-label>
              <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker1" readonly
                     formControlName="startdate">
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1 disabled="false"></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="col-12" *ngIf="offer?.offerType?.ePaper && askForEditionId">
              <mat-label [innerHTML]="translationService.getTranslation('order_edition')"></mat-label>
              <mat-select formControlName="editionId" required
                          [value]="paymentFormGroup.get('editionId').value">
                <ng-container *ngFor="let variantCode of offer?.product?.variantCodeList">
                  <mat-option [value]="variantCode">{{ variantCodeDescriptions?.get(variantCode) }}
                  </mat-option>
                </ng-container>
              </mat-select>
              <mat-error
                *ngIf="paymentFormGroup.get('editionId').hasError('message')">{{ paymentFormGroup.get('editionId').getError('message') }}
              </mat-error>
            </mat-form-field>

            <ng-container *ngIf="!privacyDisclaimerAgbInOne; else allInOne">
              <div class="col-12" *ngIf="needIbanBic && showSEPABox">
                <mat-checkbox formControlName="sepaOptIn" required aria-required="true" class="text-wrap" #sepaBox>
                  <div [innerHTML]="translationService.getTranslation('order_sepaaccept')" > </div>
                </mat-checkbox>
                <mat-error class="small errorOffset" *ngIf="!sepaBox.checked && checkBoxes"
                           [innerHTML]="translationService.getTranslation('order_sepaaccept_error')"></mat-error>
              </div>

              <div class="col-12" *ngIf="isDigitalOffer()">
                <mat-checkbox formControlName="epaperRevocationWaiver" required aria-required="true" class="text-wrap"
                              #epaperRevocationWaiverBox>
                  <div [innerHTML]="translationService.getTranslation('order_epaper_revocation_waiver')"></div>
                </mat-checkbox>
                <mat-error class="small errorOffset" *ngIf="!epaperRevocationWaiverBox.checked && checkBoxes"
                           [innerHTML]="translationService.getTranslation('order_epaper_revocation_waiver_error')"></mat-error>
              </div>

            </ng-container>
            <ng-template #allInOne>
              <div class="col-12" *ngIf="needIbanBic && showSEPABox">
                <mat-checkbox formControlName="sepaOptIn" required aria-required="true" class="text-wrap" #sepaBox>
                  <div [innerHTML]="translationService.getTranslation('order_sepaaccept')" > </div>
                </mat-checkbox>
                <mat-error class="small errorOffset" *ngIf="!sepaBox.checked && checkBoxes"
                           [innerHTML]="translationService.getTranslation('order_sepaaccept_error')"></mat-error>
              </div>

              <div class="col-12" *ngIf="isDigitalOffer()">
                <mat-checkbox formControlName="epaperRevocationWaiver" required aria-required="true" class="text-wrap"
                              #epaperRevocationWaiverBoxAllInOne>
                  <div [innerHTML]="translationService.getTranslation('order_epaper_revocation_waiver')"></div>
                </mat-checkbox>
                <mat-error class="small errorOffset" *ngIf="!epaperRevocationWaiverBoxAllInOne.checked && checkBoxes"
                           [innerHTML]="translationService.getTranslation('order_epaper_revocation_waiver_error')"></mat-error>
              </div>
            </ng-template>

            <div class="float-end mt-1">
              <button class="me-3" mat-raised-button
                      matStepperPrevious
                      [innerHTML]="translationService.getTranslation('button_back')"></button>
              <button mat-raised-button [color]="paymentFormGroup.valid ? 'primary' : null"  matStepperNext [disabled]="!paymentFormGroup.valid"
                      (click)="calcPriceOfSubscription()"
                      data-cy="btn-payment-next"
                      [innerHTML]="translationService.getTranslation('button_check_price')"></button>
            </div>
          </form>
        </mat-step>

        <!-- Preisberechnung / Zusammenfassung -->
        <mat-step>
          <ng-template matStepLabel>
            <div [innerHTML]="translationService.getTranslation('step_summary')"></div>
          </ng-template>
          <ng-container *ngIf="calculatingPrice">
            <div class="text-center">
              <h4 *appApplyIfNotEmpty="translationService.getTranslation('wait_while_pricecalculation')"
                  [innerHTML]="translationService.getTranslation('wait_while_pricecalculation')"></h4>
              <app-loading-spinner [type]="'small'"></app-loading-spinner>
            </div>
          </ng-container>
          <ng-container *ngIf="!calculatingPrice">
            <div class="text-center">
              <h4 *appApplyIfNotEmpty="translationService.getTranslation(hasError ? 'error_price_calculation' : 'price_calculated')"
                  class="text-center" [innerHTML]="translationService.getTranslation(hasError ? 'error_price_calculation' : 'price_calculated')"></h4>
            </div>
          </ng-container>
          <ng-container *ngIf="creatingOrder">
            <div class="text-center">
              <h4 *appApplyIfNotEmpty="translationService.getTranslation('wait_while_orderCreating')"
                  [innerHTML]="translationService.getTranslation('wait_while_orderCreating')"></h4>
              <app-loading-spinner [type]="'small'"></app-loading-spinner>
            </div>
          </ng-container>

          <!-- Nur am Ende anzeigen, da die Internals dieses Blocks ein ziemliches Feuerwerk zünden -->
          <ng-container *ngIf="stepper.selectedIndex == stepper.steps.length-1">
            <div class="col-12 mt-4">
              <div class="row summary">
                <ng-container *ngFor="let block of getVisibleSummaryBlocks(); let idx = index">
                  <div class="p-1" [ngClass]="isLastBlockFullWidth(idx) ? 'col-12' : 'col-12 col-lg-6'">
                    <div class="p-3">
                      <b>{{ getBlockTitle(block) }}</b>
                      <div [innerHTML]="getBlockContent(block)" class="mt-2"></div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="col-12 mt-4">
              <!--
              Die Offer-Card ist an dieser Stelle zugegebenermaßen etwas oversized, um lediglich die Opt-Ins und den
              Bestell-Button anzuzeigen. Die beiden Elemente sind sehr mit der Offer-Card verwoben.
              ToDo: Opt-Ins/Bestell-Button aus OfferCard herauslösen
               -->
              <app-offer-card
                [showOnlyOptIns]="true"
                [offer]="offer"
                [showOnOfferPage]="false"
                [stepper]="stepper"
                [bonuses]="selectedBonus"
                [deliveryAddress]="selectedDeliveryAddress"
                [billingAddress]="selectedBillingAddress"
                [bonusAddress]="selectedBonusAddress"
                [paymentCode]="selectedFormOfPayment"
                [paymentFrequency]="selectedPaymentFrequency"
                [startDate]="selectedStartDate"
                [prices]="offerPrice"
                [creatingOrder]="creatingOrder"
                [onlinePayment]="showOnlinePayment"
                (save)="onCompleteOrder($event)"
                [privacyDisclaimerAgbInOne]="privacyDisclaimerAgbInOne"
                (optInsSelected)="onOptInsSelected($event)"
                (agbChecked)="onAgbChecked($event)"
              ></app-offer-card>
            </div>
          </ng-container>
          <br>
          <ng-container *ngIf="showOnlinePayment && agbChecked">
            <app-onlinepayment></app-onlinepayment>
          </ng-container>
        </mat-step>

      </mat-stepper>
    </div>
    <div class="col-12 col-md-4">
      <app-offer-card
        [offer]="offer"
        [showOnOfferPage]="false"
        [stepper]="stepper"
        [bonuses]="selectedBonus"
        [deliveryAddress]="selectedDeliveryAddress"
        [billingAddress]="selectedBillingAddress"
        [bonusAddress]="selectedBonusAddress"
        [paymentCode]="selectedFormOfPayment"
        [paymentFrequency]="selectedPaymentFrequency"
        [startDate]="selectedStartDate"
        [prices]="offerPrice"
        [creatingOrder]="creatingOrder"
        [onlinePayment]="showOnlinePayment"
        (save)="onCompleteOrder($event)"
        [privacyDisclaimerAgbInOne]="privacyDisclaimerAgbInOne"
        (optInsSelected)="onOptInsSelected($event)"
      ></app-offer-card>
    </div>
  </div>
</div>


<div class="mt-3 float-end">
  <button *ngIf="showBackToOverviewButton && !isLoadingView" mat-raised-button
          (click)="backToOverview()"
          [innerHTML]="translationService.getTranslation('button_back_to_overview')"></button>
</div>
